import { CategoryPageQuery } from '@elevio-kb/queries/dist/types';
import { useSelector } from '../actions/types';
import * as selectors from '../selectors';
import { Maybe } from '../utils/types';

type Result = {
  fetchingStatus: selectors.FetchingStatus;
  data: Maybe<CategoryPageQuery>;
};

export default function useCategoryPageData(categoryId: string): Result {
  const fetchingStatus = useSelector(state =>
    selectors.categoryPageFetchingStatus(state, categoryId)
  );

  const data = useSelector(state =>
    selectors.getCategoryPageData(state, categoryId)
  );

  return {
    fetchingStatus,
    data,
  };
}
